import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { happyHolidaysHomeCarouselBanner } from '@ibk/shared-assets';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { ApiProductStatus, FeatureFlagUseCase } from '@ibk/shared-types';
export const useHappyHolidaysHomeBanner = (product, isActive = true) => {
    const navigate = useNavigate();
    const { isFeatureFlagWhiteListed } = useFeatureFlag();
    const isEnabled = isActive && isFeatureFlagWhiteListed(FeatureFlagUseCase.BENEFICIOS_RECARGA_BOAS_FESTAS);
    return useMemo(() => {
        if (!isEnabled)
            return null;
        const onClick = product && !product.isLoading && !product.error
            ? () => {
                if (product.data?.status === ApiProductStatus.ACTIVE) {
                    navigate('/beneficios/nova-recarga', {
                        state: { rechargeType: 'HAPPY_HOLIDAYS_END_OF_THE_YEAR' },
                    });
                }
                else {
                    navigate('/beneficios');
                }
            }
            : undefined;
        return {
            id: 'home-happy-holidays',
            image: happyHolidaysHomeCarouselBanner,
            imageFit: 'fill',
            onClick,
        };
    }, [isEnabled, product, navigate]);
};
